@if (selectedRequest()) {
    <div>
        <!-- Stepper visual horizontal -->
        <div class="mb-3 mt-1 mt-md-2 mb-md-4">
            <app-timeline
                [steps]="timelineSteps()"
                [currentStep]="currentStep()"
                [allowAllSteps]="true"
                (stepChange)="currentStep.set($event)">
            </app-timeline>
        </div>

        <div class="panel mb-4" [class.panel-documentos-mobile]="currentStepObj()?.title === 'Documentos'">
            <div class="step-header d-none d-md-flex align-items-center justify-content-between gap-3">
                <div class="d-flex align-items-center gap-3">
                    <h5 class="mb-0 text-dark fw-bold text-nowrap">
                        @switch (currentStepObj()?.title) {
                            @case ('Socio') {
                                <i class="fas fa-user me-2 text-primary"></i>Datos del Socio
                            }
                            @case ('Vehículo') {
                                <i class="fas fa-car me-2 text-primary"></i>Datos del Vehículo
                            }
                            @case ('Documentos') {
                                <i class="fas fa-folder-open me-2 text-primary"></i>Documentos a Revisar
                            }
                            @case ('Aprobación') {
                                <i class="fas fa-gavel me-2 text-primary"></i>Aprobación de la Solicitud
                            }
                        }
                    </h5>

                </div>
                <app-flow-badge
                    display="badge"
                    [processSlug]="selectedRequest()?.processSlug"
                    [statusSlug]="selectedRequest()?.statusSlug">
                </app-flow-badge>
            </div>

            <!-- Paso: Socio -->
            <div class="step-body" [class.d-none]="currentStepObj()?.title !== 'Socio'">
                <app-party-form [partyForm]="partyForm" [mode]="formMode.VIEW"></app-party-form>
            </div>

            <!-- Paso: Vehículo -->
            @if (hasVehicleStep()) {
                <div class="step-body" [class.d-none]="currentStepObj()?.title !== 'Vehículo'">
                    <app-vehicle-form
                        [vehicleForm]="vehicleForm"
                        [mode]="formMode.VIEW"
                        [isReadOnly]="true">
                    </app-vehicle-form>
                    @if (isVehicleUpdate() && proposedChangeRows().length) {
                        <div class="mt-4">
                            <h6 class="fw-bold text-dark mb-2">
                                <i class="fas fa-exchange-alt text-primary me-2"></i>Cambios propuestos
                            </h6>
                            <div class="table-responsive">
                                <table class="table table-sm table-bordered mb-0">
                                    <thead class="table-light">
                                        <tr>
                                            <th>Campo</th>
                                            <th>Actual</th>
                                            <th>Propuesto</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        @for (row of proposedChangeRows(); track row.key) {
                                            <tr>
                                                <td>{{ row.label }}</td>
                                                <td>{{ row.from }}</td>
                                                <td class="fw-semibold text-primary">{{ row.to }}</td>
                                            </tr>
                                        }
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    }
                </div>
            }

            <!-- Paso: Documentos (solo si hay checklist) -->
            @if (hasDocumentChecklist()) {
            <div class="step-body" [class.d-none]="currentStepObj()?.title !== 'Documentos'">
                @if (isObserved() && observationReason()) {
                    <div class="alert alert-warning small mb-3">
                        <i class="fas fa-exclamation-triangle me-1"></i>
                        Observación: {{ observationReason() }}
                    </div>
                }
                <app-document-approval
                    #documentApproval
                    [referenceData]="selectedRequest()"
                    [canApprove]="canReviewDocuments()"
                    [canFinalApprove]="canFinalApproveDocs()"
                    [allowObservation]="canObserveDocs()"
                    [canReplace]="canReplaceObserved()"
                    (onReviewCompleted)="onReviewCompleted()"
                    (onUploadFile)="onUploadDocumentFile($event)"
                    (hasObservedChange)="hasObservedDocs.set($event)"
                    (readinessChange)="onDocumentsReadiness($event)">
                </app-document-approval>
                @if (canResubmit() && !appSettings.isMobile()) {
                    <div class="d-flex justify-content-end mt-3">
                        <button type="button" class="btn btn-warning px-4"
                            [disabled]="isProcessingApproval() || hasObservedDocs() || (hasDocumentChecklist() && !allRequiredDocsUploaded())"
                            (click)="resubmitObservation()">
                            <i class="fas fa-paper-plane me-1"></i>
                            Reenviar a revisión
                        </button>
                    </div>
                }
            </div>
            }

            <!-- Paso: Aprobación — timeline BPM + ficha (acciones en footer) -->
            @if (currentStepObj()?.title === 'Aprobación') {
                <div class="step-body">
                    <div class="approval-summary">
                        <app-flow-steps
                            [request]="selectedRequest()"
                            layout="timeline">
                        </app-flow-steps>

                        <div class="approval-pdf-toggle">
                            <button type="button" class="btn btn-outline-danger btn-sm px-2.5 py-1 text-nowrap"
                                (click)="openPdfInforme()" title="Ver ficha de solicitud en PDF">
                                <i class="fas fa-file-pdf me-1"></i> Ficha PDF
                            </button>
                        </div>
                    </div>
                </div>
            }

            @if (currentStepObj()?.title === 'Aprobación' && !appSettings.isMobile()) {
                <div class="step-footer step-footer--approval">
                    <button type="button" class="btn btn-outline-secondary btn-sm px-3" (click)="prevStep()">
                        <i class="fas fa-arrow-left me-2"></i> Anterior
                    </button>
                    <app-bpm
                        class="step-footer__bpm"
                        [request]="selectedRequest()"
                        [isProcessing]="isProcessingApproval()"
                        [blockedReason]="bpmBlockedReason()"
                        (approve)="approveRequest()"
                        (reject)="rejectRequest()"
                        (confirmed)="onStepApprovalConfirmed($event)">
                    </app-bpm>
                </div>
            } @else if (currentStepObj()?.title !== 'Aprobación' && !appSettings.isMobile()) {
                <div class="step-footer">
                    <button class="btn btn-outline-secondary btn-sm px-3" (click)="prevStep()" [disabled]="currentStep() === 1">
                        <i class="fas fa-arrow-left me-2"></i> Anterior
                    </button>
                    <button class="btn btn-primary btn-sm px-3" (click)="nextStep()" [disabled]="currentStep() === timelineSteps().length">
                        Siguiente <i class="fas fa-arrow-right ms-2"></i>
                    </button>
                </div>
            }
        </div>

        <app-membership-informe-pdf
            #membershipPdf
            [request]="selectedRequest()"
            [party]="selectedRequest()?.party"
            [vehicle]="selectedRequest()?.vehicle">
        </app-membership-informe-pdf>
    </div>
}

@if (appSettings.isMobile() && currentStepObj()?.title === 'Aprobación') {
    <div class="bpm-mobile-host" aria-hidden="true">
        <app-bpm
            [request]="selectedRequest()"
            [isProcessing]="isProcessingApproval()"
            [blockedReason]="bpmBlockedReason()"
            [hideButtons]="true"
            (approve)="approveRequest()"
            (reject)="rejectRequest()"
            (confirmed)="onStepApprovalConfirmed($event)">
        </app-bpm>
    </div>

    <app-mobile-footer [visible]="showApprovalMobileFooter()">
        @if (showRejectMobile()) {
            <button type="button"
                class="btn btn-outline-danger btn-sm"
                [disabled]="isProcessingApproval()"
                (click)="onMobileReject()">
                <i class="fas fa-times me-1"></i>Rechazar
            </button>
        }
        @if (canActApproval()) {
            <span class="d-inline-flex flex-grow-1" [attr.title]="bpmBlockedReason() || null">
                <button type="button"
                    class="btn btn-success btn-sm w-100"
                    [disabled]="!canConfirmApproval() || isProcessingApproval()"
                    (click)="onMobileApprove()">
                    @if (isProcessingApproval()) {
                        <span class="spinner-border spinner-border-sm me-1"></span>
                    }
                    <i class="fas fa-check-circle me-1"></i>{{ approveMobileLabel() }}
                </button>
            </span>
        }
    </app-mobile-footer>
}
